module.exports = __webpack_public_path__ + "static/media/DH_TreatmentTypes_v2FINAL.0907cfa5.mp4";